<template>
    <div class="toggle_option" :class="isVisible ? 'tooltipHide' : ''">
        <div
            @click="isVisible = !isVisible"
            class="toggle_option-trigger"
        >
            <slot name="toggleTitle"/>
        </div>
        <div
            v-show="isVisible"
            class="toggle_option-container"
        >
            <slot></slot>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                isVisible: false
            }
        }
    }
</script>

<style lang="scss" scoped>
    .toggle_option {
        position: absolute;
        width: 100%;
        box-sizing: border-box;
        font-size: 12px;
    }
    .toggle_option-trigger {
        display: flex;
        align-items: center;
        padding: 9px 5px 8px 5px;
        cursor: pointer;
    }
    .toggle_option-container {
        padding: 15px 6px 6px;
        background-color: #f5f5f5;
        box-shadow: 5px 8px 10px 0px #D4D4D4;
    }
    @media (max-width: 1200px) {
        .toggle_option {
            padding: 3px 0;
        }
        .toggle_option-trigger {
            padding: 5px 2px;
        }
    }
</style>